import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import ClassAssemblySidebar2026 from '../ClassAssemblySidebar2026';

const ClassAssembly12B2026 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const [config, setConfig] = useState({ base_image_url_2026: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const photos = Array.from({ length: 10 }, (_, index) => {
    const src = `${config.base_image_url_2026}/home/events-activities/class-assembly/12B/${index + 1}.webp`;

    return {
      src,
      source: src,
      rows: 1,
      cols: 1,
    };
  });

  return (
    <Main>
      <Container>
        <Grid container spacing={4}>
          <Grid item xs={12} md={8}>
            <Box>
              <Box>
                
                <Typography variant="h5" align="center">
                  THE PRICE OF A BREATH
                </Typography>
                <Typography fontSize="x-small">
                  <br />
                  <br />
                  Class: 12B Date: 4 &amp; 5 June 2026
                </Typography>

                <br />
                <Typography variant={'subtitle1'} align={'justify'}>
                  On June 5, 2026 the students of Class 12 B presented a special assembly titled <strong>&lsquo;The Price of a Breath&rsquo;</strong>, on the occasion of World Environment Day. The program began with an inspiring message, followed by a graceful dance and a poignant skit depicting a drought-stricken farmer&rsquo;s plight, later shifting to a dystopian 2050 where oxygen is a costly privilege. It concluded with a powerful confrontation as a child questioned policymakers on the denial of his right to live, exposing their evasion of responsibility.
                  <br />
                  The assembly concluded with a compelling message on environmental stewardship and shared responsibility. Echoing the timeless words of Mahatma Gandhi, &lsquo;We have not inherited this Earth from our ancestors; we have borrowed it from our children,&rsquo; the presentation urged the younger generation to conserve natural resources, adopt sustainable practices and safeguard the planet for posterity.
                  <br />
                </Typography>
              </Box>
              <Typography
                variant={'h6'}
                color={'primary'}
                align={'center'}
                fontWeight={'normal'}
              >
                <br />
                &ldquo;What you do makes a difference and you have to decide what kind of difference you want to make&rdquo;
                <br />
              </Typography>

              <Box>
                <ImageList
                  variant="quilted"
                  cols={2}
                  rowHeight={isMd ? 200 : 100}
                  gap={isMd ? 16 : 4}
                >
                  {photos.map((item, i) => (
                    <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                      <LazyLoadImage
                        height={'100%'}
                        width={'100%'}
                        src={item.src}
                        alt="Class Assembly 12B 2026"
                        effect="blur"
                        onClick={() => openLightbox(i)}
                        style={{
                          objectFit: 'cover',
                          filter:
                            theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                          cursor: 'pointer',
                          borderRadius: 8,
                        }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Box>
              {viewerIsOpen && (
                <Lightbox
                  mainSrc={photos[currentImage].src}
                  nextSrc={photos[(currentImage + 1) % photos.length].src}
                  prevSrc={
                    photos[(currentImage + photos.length - 1) % photos.length].src
                  }
                  onCloseRequest={() => closeLightbox()}
                  onMovePrevRequest={() =>
                    setCurrentImage((currentImage + photos.length - 1) % photos.length)
                  }
                  onMoveNextRequest={() =>
                    setCurrentImage((currentImage + 1) % photos.length)
                  }
                  reactModalStyle={{ overlay: { zIndex: 1500 } }}
                />
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={4}>
            <Box marginBottom={4}>
              <ClassAssemblySidebar2026 />
            </Box>
            <Box marginBottom={4}>
              <Archive2022 />
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Main>
  );
};

export default ClassAssembly12B2026;
